<template>
  <div :class="campaignClass" :style="campaignBg">
    <div class="inner-content" v-if="campaign.title.rendered">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CampaignDetail',

  mounted () {
    this.$store.dispatch('getCampaign', this.$route.params.slug)
  },

  computed: {
    campaign () {
      return this.$store.getters.campaign
    },

    campaignClass () {
      return this.$route.name === 'campaign' ? 'campaign' : 'campaign ' + this.$route.name
    },

    campaignBg () {
      if (this.$route.name === 'campaign') {
        let bg = this.$store.getters.campaignBg
        return bg !== false ? { 'background-image': 'url(' + bg + ')' } : false
      } else {
        return {}
      }
    },
  },

  beforeRouteLeave (to, from, next) {
    this.$store.commit('clearHero')
    next()
  }
}
</script>
